import { render, staticRenderFns } from "./Tktz.vue?vue&type=template&id=aa89c8ec&scoped=true"
import script from "./Tktz.vue?vue&type=script&lang=js"
export * from "./Tktz.vue?vue&type=script&lang=js"
import style0 from "./Tktz.vue?vue&type=style&index=0&id=aa89c8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89c8ec",
  null
  
)

export default component.exports